/** src/pages/NotFound.jsx */
export default function NotFound() {
    return(
        <main>
            <article>
                <section>
                    <h1>Error 404: Page not found</h1>
                    <p>Oops...We can't seem to find the page you're looking for</p>
                    <a href="/">Back to homepage</a>
                </section>
            </article>
        </main>
    )
}